import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwing = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_162",
		"data-name": "Group 162",
		transform: "translate(0.5 0.5)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_49",
			"data-name": "Rectangle 49",
			width: 72.551,
			height: 33.802,
			fill: "none",
			stroke: "#040505",
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_161",
			"data-name": "Group 161",
			transform: "translate(20.463 1.18)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_305",
					"data-name": "Path 305",
					d: "M871.889,484.565a2.276,2.276,0,0,0-1.377-2.149c-.358-.163-.771-.343-1.212-.536a22.947,22.947,0,0,1-4.752-2.472c-1.165-1.137-3.976-4.661-5.13-6.123a1.252,1.252,0,0,0-.611-.416c.053-.243.117-.5.2-.773.563-1.759,2.015-6.128,2.03-6.172a1.055,1.055,0,0,0-2-.666c-.015.044-1.47,4.423-2.037,6.193a9.474,9.474,0,0,0-.485,3.1c-.016.031-.032.059-.048.091a3.376,3.376,0,0,1-2-.372,4.25,4.25,0,0,1-1.208-1.291c-.025-.039-.059-.07-.086-.107.181-.339.4-.776.675-1.347a30.545,30.545,0,0,0,1.675-6.514,1.056,1.056,0,1,0-2.088-.318,28.049,28.049,0,0,1-1.483,5.9c-.365.744-.586,1.169-.716,1.408a2.141,2.141,0,0,0-1.237.553,10.47,10.47,0,0,0-1.307,1.493,19.137,19.137,0,0,0-1.884,3.128c-.226.116-.608.423-1.618,1.729a1.054,1.054,0,0,0-.168.974,6.568,6.568,0,0,0,3.894,3.6c2.728,1.154,11.868,3.974,12.3,4.107a20.619,20.619,0,0,0,4.643.592,9.213,9.213,0,0,0,3.29-.518C870.829,487.009,871.855,485.849,871.889,484.565Zm-20.037-12.672a1.071,1.071,0,0,0-.332.068A1.073,1.073,0,0,1,851.852,471.892Zm9.938,13.672c-.093-.029-9.425-2.908-12.054-4.02a5.463,5.463,0,0,1-2.461-1.864c.231-.28.441-.52.557-.636l.147-.058a1.06,1.06,0,0,0,.6-.594,15.837,15.837,0,0,1,1.813-3.087,7.424,7.424,0,0,1,1.063-1.2c.016,0,.02.008.021.011h0a6.254,6.254,0,0,0,1.839,1.928,5.764,5.764,0,0,0,4.1.589,1.055,1.055,0,0,0,.722-.591c.091-.2.2-.406.3-.6,1.5,1.882,3.6,4.456,4.634,5.471.932.91,2.9,1.812,5.381,2.9.432.188.835.365,1.184.524.143.065.142.131.141.171-.007.262-.386.8-1.4,1.194C866.4,486.476,862.919,485.856,861.79,485.564Z",
					transform: "translate(-841.191 -463.803)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_306",
					"data-name": "Path 306",
					d: "M891.952,516.852h-3.167a1.056,1.056,0,1,0,0,2.111h3.167a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-861.382 -488.851)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_307",
					"data-name": "Path 307",
					d: "M867.234,516.852h-7.726a1.056,1.056,0,1,0,0,2.111h7.726a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-847.559 -488.851)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_308",
					"data-name": "Path 308",
					d: "M842.037,516.852H838.87a1.056,1.056,0,0,0,0,2.111h3.167a1.056,1.056,0,0,0,0-2.111Z",
					transform: "translate(-837.814 -488.851)",
					fill: "#040505"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgSwing);
export { ForwardRef as ReactComponent };
